<template>
  <div>
    <div class="alert alert-info alert-dismissible">
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      <strong>Fique ligado!</strong> Para garantir uma melhor experiência aos
      usuários, reordenamos a exibição dos registros desta página!
      <br />
      A partir de agora, estamos exibindo reservas ordenadas pela
      <strong>data de início</strong>, da mais recente, para a mais antiga.
    </div>
    <base-crud
      crudName="Reservas de Estação de Trabalho"
      newText="Novo Agendamento"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="$store.state.user.access_nivel == 3 ? true : false"
      :enableView="true"
      :dataForm="dataForm"
      :customFilters="customFilters"
      @sDate="sDate"
      @eDate="eDate"
      :extra="extra"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "date_start",
          type: "calendar",
          call: "sDate",
        },
        {
          name: "date_end",
          type: "calendar",
          call: "eDate",
        },
      ],

      extra: [],
      table: "schedulesTable",
      columns: [
        "id",
        "user_id",
        "workstation_id",
        "place_id",
        "place_title",
        "date_start",
        "date_end",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "workstation_id",
        "place_id",
        "place_title",
        "date_start",
        "date_end",
        "status",
      ],
      options: {
        sortable: [
          "id",
          "user_id",
          "workstation_id",
          "place_id",
          "place_title",
          "date_start",
          "date_end",
          "status",
        ],
        filterable: [
          "id",
          "user_id",
          "workstation_id",
          "status",
          "place_title",
          "place_id",
        ],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Nome do Responsável",
          workstation_id: "Estação de Trabalho",
          place_id: "ID Posição",
          place_title: "Nome Posição",
          date_start: "Data Início",
          date_end: "Data Final",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Reservado",
            },
            {
              id: 2,
              text: "Confirmado",
            },
            {
              id: 3,
              text: "Em andamento",
            },
            {
              id: 4,
              text: "Finalizada",
            },
            {
              id: 5,
              text: "Cancelada",
            },
          ],
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          workstation_id: function (h, row, index) {
            return row.workstation ? row.workstation.title : "Sem Nome";
          },
          place_title: function (h, row, index) {
            return row.place ? row.place.title : "Sem Nome";
          },
          status: function (h, row, index) {
            switch (row.status) {
              case 1:
                return "Reservado";
                break;
              case 2:
                return "Confirmado";
                break;
              case 3:
                return "Em andamento";
                break;
              case 4:
                return "Finalizada";
                break;
              case 5:
                return "Cancelada";
                break;
            }
            return;
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);

          requestData.params = data;

          if (
            this.$parent.$parent.date_start != null &&
            this.$parent.$parent.date_start != ""
          ) {
            requestData.params.date_start = this.$parent.$parent.date_start;
          }

          if (
            this.$parent.$parent.date_end != null &&
            this.$parent.$parent.devolution_date != ""
          ) {
            requestData.params.devolution_date =
              this.$parent.$parent.devolution_date;
          }

          requestData.params.query = "";
          requestData.params.with = ["user", "workstation", "place"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "schedule_workstations/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    sDate(date) {
      console.log(date);
      this.date_start = date;
    },
    eDate(date) {
      console.log(date);
      this.date_end = date;
    },
    checkins(data) {
      s;
      this.$router.push({ path: "/process/checkin/" + data.row.id });
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        workstation_id: "workstation[title]",
        status: "status",
        date_start: "date_start",
        date_end: "date_end",
        place_title: "place[title]",
        place_id: "place_id",
      };
      let filters = "orderByDesc=date_start&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleWorkstations/Crud.vue